import React from 'react';
import headerActions from '../../../../actions/header';
import translate from '../../../../utils/translate';

export default class TopLinksLogout extends React.Component {
  static propTypes = {
    links: React.PropTypes.object
  };

  logout = () => {
    headerActions.logout(this.props.links.logout);
  };

  render () {
    // TODO, refactor, its soo similar to btnlanguage

    return (
      <button
        className="toplinks__button"
        onClick={this.logout}>
        {translate('topLinksModule', 'LOG_OUT')}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/toplinks/btnlogout/index.js